export const FILE_TYPES = {
    PDF: 'application/pdf',
    DOC: 'application/msword',
    DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    JPG: 'image/jpeg',
    PNG: 'image/png',
    TXT: 'text/plain',
    CSV: 'text/csv',
};
